import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { Typography, Box, CircularProgress } from "@mui/material";
import StyledTableCell from "../../StyledTable/StyledTableCell/StyledTableCell";
import StyledTableRow from "../../StyledTable/StyledTableRow/StyledTableRow";
import DeleteModal from "../../../../../Modals/DeleteModal/DeleteModal";
import InlineIconButton from "../../../../../Buttons/InlineIconButton/InlineIconButton";
import EditIcon from "@mui/icons-material/Edit";
import { formatCurrency } from "../../../../../../utils/formatHelpers";
import { CarrierService } from "../../../../../../services/CarrierService";
import { AlertContext } from "../../../../../Dashboard/Dashboard";

export default function StagedAccessorialsTableRow({
  accessorial,
  setAccessorialToEdit,
  handleDeleteAccessorial,
  setStep,
  submitAll,
  handleUpdateAccessorial,
  setDeleteModalOpen
}) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [status, setStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const handleEdit = () => {
    setAccessorialToEdit(accessorial);
    setStep(1);
  };

  useEffect(() => {
    if (submitAll && !accessorial.submitted) {
      setIsLoading(true);

      const payload = {
        amount: accessorial.totalAmount,
        rate: accessorial.amount,
        quantity: accessorial.quantity,
        currency: "USD",
        deductCodeId: accessorial.deductCodeId,
        shortDescription: accessorial.shortDescription,
        description: accessorial.description,
        carrierId: accessorial.carrierId,
        enteredUserId: accessorial.enteredUserId,
        movementId: accessorial.movementId,
        orderId: accessorial.orderId,
        stopId: accessorial.stopId,
        transactionDate: new Date().toISOString()
      }; 
      
      if (accessorial.accessorialId) {
        payload.id = accessorial.accessorialId;

        CarrierService.UpdateCarrierExtraPay(instance, payload).then(() => {
          accessorial.submitted = true;
          handleUpdateAccessorial(accessorial);
          setStatus("Submitted");
          setIsLoading(false);
        }).catch(error => {
          console.error(error);
          setStatus("Error");
          setIsLoading(false);
          warning(error);
        });
      } else {
        CarrierService.CreateCarrierExtraPay(instance, payload).then(() => {
          accessorial.submitted = true;
          handleUpdateAccessorial(accessorial);
          setStatus("Submitted");
          setIsLoading(false);
        }).catch(error => {
          console.error(error);
          setStatus("Error");
          setIsLoading(false);
          warning(error);
        });
      }
    }
  }, [submitAll]);

  useEffect(() => {
    setStatus(accessorial.status);
    if (accessorial.submitted) {
      setStatus("Submitted");
    }
  }, [accessorial]);

  useEffect(() => {
    setDeleteModalOpen(deleteOpen);
  }, [deleteOpen]);

  return (
    <StyledTableRow>
      <StyledTableCell>
        <Typography variant="body1" color="black_solid.80">
          {accessorial.quantity}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography variant="body1" color="black_solid.80">
          {accessorial.accType}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography variant="body1" color="black_solid.80">
          {accessorial.stopSequence}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography variant="body1" color="black_solid.80">
          {formatCurrency(accessorial.amount, 2)}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography variant="body1" color="black_solid.80">
          {formatCurrency(accessorial.totalAmount, 2)}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        {isLoading ? (
          <CircularProgress sx={{ color: "primary.60" }} size={20} />
        ) : (
          <Typography variant="body1" color="black_solid.80">
            {status}
          </Typography>
        )}
      </StyledTableCell>
      <StyledTableCell>
        <Box sx={{ display: "flex" }}>
          <Box sx={{ marginRight: "10px" }}>
            <InlineIconButton 
              onClick={handleEdit} 
              disabled={submitAll || accessorial.submitted} 
              icon={EditIcon}
              buttonColor="grey"
            />
          </Box>
          <Box>
            <DeleteModal 
              handleDelete={() => handleDeleteAccessorial(accessorial)}
              type={`${accessorial.accType} accessorial`}
              disabled={submitAll || accessorial.submitted}
              isLoading={isLoading}
              open={deleteOpen}
              setOpen={setDeleteOpen}
            />
          </Box>
        </Box>
      </StyledTableCell>
    </StyledTableRow>
  );
}

StagedAccessorialsTableRow.propTypes = {
  accessorial: PropTypes.object.isRequired,
  setAccessorialToEdit: PropTypes.func.isRequired,
  handleDeleteAccessorial: PropTypes.func.isRequired,
  setStep: PropTypes.func.isRequired,
  submitAll: PropTypes.bool,
  handleUpdateAccessorial: PropTypes.func.isRequired,
  setDeleteModalOpen: PropTypes.func.isRequired
};